import React from 'react';
import { oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Info } from '@one-thd/sui-icons';

const VirtualAssistanceTooltip = React.forwardRef(({ channel }, buttonRef) => {

  const tooltipContent = (
    <div className="sui-p-2 sui-w-96">
      <div className="sui-pb-3 sui-leading-loose">
        <p className="sui-font-bold">HOW IT WORKS</p>
        <p>What can we help you with?</p>
        <ul className="sui-list-disc sui-ml-4 sui-pl-3">
          <li>Available styles</li>
          <li>How to measure</li>
          <li>Custom door/window designs</li>
          <li>Pro orders</li>
          <li>Installation</li>
        </ul>
      </div>
      <ol className="sui-ml-4 sui-list-decimal sui-leading-relaxed">
        <li className="sui-pb-3">
          <p className="sui-font-bold">Call now or Request a free virtual appointment</p>
          <p>
            Call 1-833-HDAPRON (432-7766) Monday - Friday from 9 a.m - 11 p.m EST &amp; Saturday - Sunday
            from 9 a.m - 9 p.m EST, or request a free
            virtual appointment to schedule a time to speak with a door and window associate.
          </p>
        </li>
        <li className="sui-pb-3">
          <p className="sui-font-bold">Speak with an associate</p>
          <p>
            How can we help? Whether you have questions about product availability or features or
            need a quote for a custom door or window solution, we&apos;ve got you covered.
          </p>
        </li>
        <li className="sui-pb-3">
          <p className="sui-font-bold">We&apos;ll follow up</p>
          <p>We&apos;ll make sure you have everything you need for your project!</p>
        </li>
      </ol>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className="sui-underline" ref={buttonRef}>
        <div className="sui-flex sui-mt-1">
          <div>What to Expect</div>
          <div className="sui-ml-1 sui-mt-1"><Info size="small" /></div>
        </div>
      </button>
    </Tooltip>
  );
});

VirtualAssistanceTooltip.displayName = 'ProductAddOns-virtual-assistance-tooltip';

VirtualAssistanceTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
};

VirtualAssistanceTooltip.defaultProps = {
  channel: 'desktop',
};

export { VirtualAssistanceTooltip };